<template>
  <!-- 時間外管理詳細画面 -->
  <CCard>
    <CCardHeader>
      <h2>予定外時間外報告詳細</h2>
    </CCardHeader>
    <CCardBody>
      <CRow>
        <div class="container">
          <table class="table">
            <tr>
              <th scope="row">申請日</th>
              <td>
                {{ updated_at }}
              </td>
            </tr>
            <tr>
              <th scope="row">予定時間外勤務時間</th>
              <td>
                {{ overtime }}時間
              </td>
            </tr>
            <tr>
              <th scope="row">発生理由</th>
              <td>
                {{ reason }}
              </td>
            </tr>
          </table>
          <CRow class="mt-3 align-items-center">
              <CCol class="text-start">
                <router-link :to="{ name: overTimesList }">
                  <button class="btn btn-secondary">戻る</button>
                </router-link>
              </CCol>
              <CCol class="text-center">
                <router-link
                  :to="{
                    name: overTimesEdit,
                    params: { value: $route.params.value },
                  }"
                >
                  <button class="btn btn-info">編集</button>
                </router-link>
              </CCol>
              <CCol></CCol>
            </CRow>
        </div>
      </CRow>
    </CCardBody>
  </CCard>
</template>

<script>
import ConstList from "./../../ConstList";
import axios from "axios";
export default {
  name: "Info",
  data() {
    return {
      overtime: 0,
      updated_at: "",
      reason: "",
      overTimesList: "",
      overTimesEdit: "",
    };
  },

  created() {
    this.overTimesList = ConstList.ROUTE_OVERTIMES_LIST;
    this.overTimesEdit = ConstList.ROUTE_OVERTIMES_EDIT;
  },

  // DBから各種情報を取得
  mounted: function () {
    this.id = this.$route.params.id;
    const id = parseInt(this.id);
    axios
      .get(process.env.VUE_APP_API_ORIGIN + "/overtime/" + id)
      .then((response) => {
        if (response.data.length === 0) {
          this.errors.push(ConstList.EMPTY);
        }
        const overtimeData = response.data;
        this.overtime = overtimeData.overtime;
        this.updated_at = overtimeData.updated_at;
        this.reason = overtimeData.reason;
      })
      .catch((error) => {
        axios
        .get(
          `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
        )
        .then(() => {
          alert(ConstList.SYSTEM_ERROR);
        })
        .catch(() => {
          alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
        });
      });
  },
};
</script>

<style scoped>
button:disabled {
  cursor: not-allowed;
}
.container {
  margin-left: 0%;
}
</style>
